import { apiPost } from '@/composables/useApi'

const STORAGE_KEY = 'gs_referral_code'
const CODE_PATTERN = /^[ABCDEFGHJKLMNPQRSTUVWXYZ23456789]{6}$/

export function normalizeReferralCode(code) {
  return String(code || '').trim().toUpperCase()
}

export function isReferralCodeFormat(code) {
  return CODE_PATTERN.test(normalizeReferralCode(code))
}

// 邀请码一直保存在本机，直到登录后交给后端绑定
export function getPendingReferralCode() {
  return localStorage.getItem(STORAGE_KEY) || ''
}

export function setPendingReferralCode(code) {
  localStorage.setItem(STORAGE_KEY, normalizeReferralCode(code))
}

export function clearPendingReferralCode() {
  localStorage.removeItem(STORAGE_KEY)
}

export function buildReferralLink(code) {
  return `${window.location.origin}/signup?ref=${code}`
}

export async function validateReferralCode(code) {
  const normalized = normalizeReferralCode(code)
  if (!isReferralCodeFormat(normalized)) return false
  const data = await apiPost('/api/referral/validate', { code: normalized }, { auth: false })
  return data.valid
}

export function fetchReferralSummary() {
  return apiPost('/api/referral/summary', {})
}

export function bindReferralCode(code) {
  return apiPost('/api/referral/bind', { code: normalizeReferralCode(code) })
}
